export const environment = {
  production: false,
  env: "preprod",
  SSO: {
    stsServer: "https://preprod-connect1.gs1.fr"
  },
  URL_Front: "https://preprod-codeonline-gln.gs1.fr/",
  URL_Back: "https://app-colgln-app-pp-ne.azurewebsites.net/api/",
  URL_ECLI: "https://preprod-monespaceclient.gs1.fr/",
  URL_NEW_CODE_ORDER: "https://preprod-monespaceclient.gs1.fr/codes/GCP",
  ACCOUNTING_PERIOD: {
    start_date: "01/01/2024",
    end_date: "03/31/2024"
  },
  APPLICATION_INSIGHTS: {
    CONNECTION_STRING: "InstrumentationKey=08759f2c-4ef2-4ea6-8710-0555975c3750;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/;ApplicationId=6a3afcd6-08e4-43da-b325-2d635a15ad32",
    SAMPLING_PERCENTAGE: 100
  }
};
